import  './styles.css';
import { Typography } from '@mui/material';
import { InfoCircleFilled } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import AntDialog from '../../../../dialogs/dialog';

interface ModalPleaScheduleInfoProps {
    show: boolean,
    toggleShow: () => void,
}

export default function ModalPleaSocioEnvironmentalInfo ({ show, toggleShow }: ModalPleaScheduleInfoProps) {


    return (
        <Modal
            width={1000}
            height={700}
            open={show}
            onCancel={toggleShow}
            title={            
                <div className="div-header">
                    <Typography className="modal-title">
                        Instruções para Preenchimento
                    </Typography>
                </div>}
            footer={
                <Button className='btn-done' type="primary" onClick={toggleShow}>
                    <Typography>Entendido</Typography>
                </Button>}>

            <div className="div-content">
                <Typography className='title'>
                    Observações:
                </Typography>
                
                <Typography className='text-content'>
                    1. Caso o projeto possua potencial de geração de impactos
                    socioambientais negativos, preencha os campos abaixo com as
                    seguintes informações: <br />
                    <br />
                    a. Descrição dos potenciais impactos negativos a serem provocados
                    pelo projeto; <br />
                    b. Nível de tratamento dos Impactos, selecionando
                    uma entre as cinco formas possíveis de tratamento, de acordo com a
                    que melhor reflete a sua realidade:
                </Typography>

                <Typography className='text-content'>
                    <span className='title'>
                        Básico
                    </span>
                    &nbsp; - As medidas de mitigação não estão definidas e não existe
                    um processo consistente para identificação, avaliação e
                    acompanhamento dos impactos socioambientais gerados pela executora
                    / projeto.
                </Typography>

                <Typography className='text-content'>
                    <span className='title'>
                        Desenvolvimento
                    </span>
                    &nbsp; - As medidas de mitigação estão parcialmente definidas para
                    algumas áreas / projetos. Existe um processo em desenvolvimento
                    para identificação, avaliação e acompanhamento dos impactos
                    socioambientais gerados pela executora e o projeto em questão está
                    incluído no escopo de acompanhamento.
                </Typography>

                <Typography className='text-content'>
                    <span className='title'>
                     Estabelecido
                    </span>
                    &nbsp; - As medidas de mitigação estão estabelecidas e definidas.
                    Existe um processo formal para identificação, avaliação e
                    acompanhamento dos impactos
                </Typography>

                <Typography className='text-content'>
                    <span className='title'>
                        Avançado
                    </span>
                    &nbsp; - As medidas de mitigação estão bem desenvolvidas e
                    claramente definidas. Existe um processo formal para
                    identificação, avaliação e acompanhamento dos impactos
                    socioambientais gerados pela executora que abrange toda a
                    estrutura da executora que garante a inclusão do projeto atual no
                    escopo de acompanhamento.
                </Typography>

                <Typography className='text-content'>
                    <span className='title'>
                        Avançado
                    </span>
                    &nbsp; - As medidas de mitigação estão bem desenvolvidas e
                    claramente definidas. Existe um processo formal para
                    identificação, avaliação e acompanhamento dos impactos
                    socioambientais gerados pela executora que abrange toda a
                    estrutura da executora que garante a inclusão do projeto atual no
                    escopo de acompanhamento.
                </Typography>

                <Typography className='text-content'>
                    2. Caso o projeto possua mais de um impacto, tanto negativo quanto
                    positivo, incluir cada um em um item separado, clicando em
                    “adicionar”.{" "}
                </Typography>
                <Typography className='text-content'>
                    c. Detalhamento da medida mitigadora do impacto, prevista a ser
                    adotada.
                </Typography>
             </div>


        </Modal>
    );
}